export class CacheUtility {
  private static cache: Record<
    string,
    {
      data: unknown;
      valid: number;
    }
  > = {};

  static save(key: string, value: any, minutes: number = 2): void {
    CacheUtility.cache[key] = {
      data: Array.isArray(value) ? [...value] : { ...value },
      valid: Date.now() + minutes * 60 * 1000,
    };
  }

  static get(key: string): any | null {
    const item = CacheUtility.cache[key];
    if (item && item.valid > Date.now()) {
      return item.data as any;
    }
    return null;
  }

  static remove(key: string): void {
    delete CacheUtility.cache[key];
  }

  static containsRemoved(key: string): void {
    const keys = Object.keys(CacheUtility.cache);
    const temp = keys.filter(x => x.includes(key));
    temp.forEach(item => {
      CacheUtility.remove(item);
    });
  }

  static removeAll(): void {
    CacheUtility.cache = {};
  }
}
